<script>
  export default {
    props: {
      active: {
        type: Boolean,
        required: false,
        default: false,
      },

      type: {
        type: String,
        requried: false,
        default: '',
      },

      title: {
        type: String,
        requried: false,
        default: '',
      },

      description: {
        type: String,
        requried: false,
        default: '',
      },

      icon: {
        type: String,
        default: '',
        required: false,
      },
    },
  };
</script>

<template>
  <div
    @click="$emit('selected', type)"
    :class="{ active: active }"
    class="container"
  >
    <div
      class="content"
    >
      <div>
        <span
          v-text="title"
          class="title"
        />

        <span
          v-text="description"
          class="description"
        />
      </div>

      <div
        v-html="icon"
        class="icon"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  .container {
    padding: 8px 16px;
    border: 1px solid $salesflow-outline-gray-medium;
    background-color: $white;
    margin-top: 16px;
    border-radius: 8px;

    &.active {
      border: 1px solid $salesflow-primary-hover;
    }
  }

  .content {
    display: flex;
    align-items: center;
    flex-grow: 1;
  }

  .title {
    display: block;
    @include salesflow-subtitle(
      $color: $salesflow-font-dark,
      $font-weight: 600
    );
  }

  .description {
    @include salesflow-subtitle;
  }

  .icon {
    margin-left: auto;
  }

</style>
